import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import "./UserCreationModal.scss";
import getStyles from "./getStyles";
import { FormHelperText, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import InputField from "../InputField";

const UserCreationModal = (props: any) => {
  const classes = getStyles();
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [orderLimit, setOrderLimit] = useState<string>("");
  const [dailyLimit, setDailyLimit] = useState<string>("");
  const [branchIds, setBranchIds] = useState<number[]>(
    props && props.selectedBranch
      ? props.selectedBranch.map((branch: any) => branch.id)
      : []
  );
  const [isDirty, setIsDirty] = useState<boolean>(false);
  const [isDuplicateEmail, setIsDuplicateEmail] = useState<boolean>(false);
  const [clickedActionButton, setClickedActionButton] = useState<boolean>(
    false
  );

  useEffect(() => {
    setIsDuplicateEmail(props.duplicateEmail);
  }, [props.duplicateEmail]);

  useEffect(() => {
    setBranchIds(
      props && props.selectedBranch
        ? props.selectedBranch.map((branch: any) => branch.id)
        : []
    );
  }, [props && props.branches, props && props.selectedBranch]);

  useEffect(() => {
    setClickedActionButton(false);

    if (props.value && props.value.id && props.action === "Edit") {
      setFirstName(props.value.firstName);
      setLastName(props.value.lastName);
      setEmail(props.value.email);
      setDailyLimit(props.value.dailyLimit);
      setOrderLimit(props.value.orderLimit);
    } else if (props.action === "Add") {
      setFirstName("");
      setLastName("");
      setEmail("");
      setDailyLimit("");
      setOrderLimit("");
      setBranchIds(
        props && props.selectedBranch
          ? props.selectedBranch.map((branch: any) => branch.id)
          : []
      );
    }
  }, [props.open]);

  function handleCreate() {
    setClickedActionButton(true);

    if (
      firstName === "" ||
      lastName === "" ||
      email === "" ||
      orderLimit === "" ||
      dailyLimit === "" ||
      branchIds.length === 0
    ) {
      setIsDirty(true);
    } else {
      setIsDirty(false);
      props.onCreate({
        firstName,
        lastName,
        email,
        dailyLimit: parseFloat(dailyLimit),
        orderLimit: parseFloat(orderLimit),
        branchIds
      });
    }
  }

  function handleClose() {
    setIsDuplicateEmail(false);
    setClickedActionButton(false);
    props.close();
  }

  function handleUpdate() {
    setClickedActionButton(true);

    if (
      firstName === "" ||
      lastName === "" ||
      email === "" ||
      orderLimit === "" ||
      dailyLimit === "" ||
      branchIds.length === 0
    ) {
      setIsDirty(true);
    } else {
      setIsDirty(false);
      props.onUpdate({
        firstName,
        lastName,
        email,
        dailyLimit: parseFloat(dailyLimit),
        orderLimit: parseFloat(orderLimit),
        branchIds
      });
    }
  }

  return (
    <Dialog
      className="UserCreationModal-dialog"
      open={props.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={true}
      maxWidth={"md"}
    >
      <DialogTitle className={classes.titleBar}>
        {props.action} User
      </DialogTitle>
      <DialogContent>
        <div>
          <div className="UserDetails--formContainer">
            <InputField
              containerClassName={"UserDetails-FirstName"}
              fieldName={"First Name"}
              textFieldClassName={"UserDetails-FirstNameText"}
              type={"text"}
              value={firstName}
              onChange={(evt: any) => setFirstName(evt.target.value)}
              placeHolder={"Required"}
              errorOutline={isDirty && firstName === ""}
              errorMessage={
                isDirty && firstName === "" ? "Enter a first name" : ""
              }
              inputProps={{
                maxLength: 64
              }}
              clickedActionButton={clickedActionButton}
            />
            <InputField
              containerClassName={"UserDetails-LastName"}
              fieldName={"Last Name"}
              textFieldClassName={"UserDetails-LastNameText"}
              type={"text"}
              value={lastName}
              onChange={(evt: any) => setLastName(evt.target.value)}
              placeHolder={"Required"}
              errorOutline={isDirty && lastName === ""}
              errorMessage={
                isDirty && lastName === "" ? "Enter a last name" : ""
              }
              inputProps={{
                maxLength: 64
              }}
              clickedActionButton={clickedActionButton}
            />
            <InputField
              containerClassName={"UserDetails-Email"}
              fieldName={"Email"}
              textFieldClassName={"UserDetails-EmailText"}
              type={"text"}
              value={email}
              onChange={(evt: any) => setEmail(evt.target.value)}
              placeHolder={"Required"}
              errorOutline={isDirty && email === ""}
              errorMessage={
                isDirty && email === ""
                  ? "Enter an email address"
                  : isDuplicateEmail
                  ? "Somebody already has this email. Please select a unique one."
                  : ""
              }
              clickedActionButton={clickedActionButton}
            />

            <InputField
              containerClassName={"UserDetails-OrderLimit"}
              fieldName={"Order Limit"}
              textFieldClassName={"UserDetails-OrderLimitText"}
              type={"number"}
              value={orderLimit}
              onChange={(evt: any) => {
                let pv;
                if (parseFloat(evt.target.value) < 0) {
                  pv = Math.abs(evt.target.value).toString();
                } else {
                  pv = evt.target.value;
                }

                if (pv === "NaN") {
                  setOrderLimit("");
                } else {
                  if (parseFloat(pv) > 99999999) {
                    setOrderLimit("99999999");
                  } else {
                    setOrderLimit(pv);
                  }
                }
              }}
              placeHolder={"Required"}
              errorOutline={
                (isDirty && orderLimit === "") ||
                (orderLimit &&
                  dailyLimit &&
                  parseFloat(orderLimit) > parseFloat(dailyLimit))
              }
              errorMessage={
                isDirty && orderLimit === ""
                  ? "Enter an order limit"
                  : orderLimit &&
                    dailyLimit &&
                    parseFloat(orderLimit) > parseFloat(dailyLimit)
                  ? "Order limit cannot exceed daily limit"
                  : ""
              }
              inputProps={{ min: 0, max: 99999999 }}
              clickedActionButton={clickedActionButton}
            />

            <InputField
              containerClassName={"UserDetails-DailyLimit"}
              fieldName={"Daily Limit"}
              textFieldClassName={"UserDetails-DailyLimitText"}
              type={"number"}
              value={dailyLimit}
              onChange={(evt: any) => {
                let pv;
                if (parseFloat(evt.target.value) < 0) {
                  pv = Math.abs(evt.target.value).toString();
                } else {
                  pv = evt.target.value;
                }

                if (pv === "NaN") {
                  setDailyLimit("");
                } else {
                  if (parseFloat(pv) > 99999999) {
                    setDailyLimit("99999999");
                  } else {
                    setDailyLimit(pv);
                  }
                }
              }}
              placeHolder={"Required"}
              errorOutline={isDirty && dailyLimit === ""}
              errorMessage={
                isDirty && dailyLimit === "" ? "Enter a daily limit" : ""
              }
              inputProps={{ min: 0, max: 99999999 }}
              clickedActionButton={clickedActionButton}
            />

            <div className="UserDetails--input-container UserDetails-Branches">
              <div className="UserDetails--input-label">Branches</div>
              <Autocomplete
                className={`${classes.branchesInputField} UserDetails-BranchesInput`}
                multiple
                id="tags-outlined"
                options={props && props.branches}
                getOptionLabel={(option: any) => option.name}
                defaultValue={props && props.selectedBranch}
                filterSelectedOptions
                onChange={(evt, values) => {
                  setBranchIds(values.map(branch => branch.id));
                }}
                renderInput={(params: any) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Branches"
                    error={isDirty && branchIds.length === 0}
                  />
                )}
              />
              <FormHelperText className={`${classes.errorMsg}`}>
                {isDirty && branchIds.length === 0
                  ? "Select at least 1 branch"
                  : ""}
              </FormHelperText>
            </div>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          className="UserCreationModal-cancel"
          color="secondary"
          onClick={() => handleClose()}
        >
          Cancel
        </Button>
        {props.action === "Add" ? (
          <Button
            className="UserCreationModal-create"
            onClick={() => handleCreate()}
            color="primary"
          >
            Create
          </Button>
        ) : (
          <Button
            className="UserCreationModal-save"
            onClick={() => handleUpdate()}
            color="primary"
          >
            Save
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default UserCreationModal;
